import React, { useEffect, useState } from 'react';
import Amplify, { Auth, Hub } from 'aws-amplify';
import awsconfig from '../.aws-config/awsconfig'
import awsauth from '../.aws-config/awsauth'
import config from '../config';

Amplify.configure(awsconfig)
Auth.configure({ oauth: awsauth })

const SignOutAll = () => {
  return (
    Auth.signOut()
    .then(() => { document.cookie = 'prwwu=;domain=.thaiticketmajor.com;path=/'; })
    .then(() => { window.location = config.URL.SIGNOUT; })
    .catch(err => console.error(err))
  )
}

const SignOut = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      // eslint-disable-next-line default-case
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          getUser()
            .then(userData => setUser(userData))

          break;
        case 'signOut':
          setUser(null);
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          console.log('Sign in failure', data);
          break;
      }
    });

    getUser().then(userData => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(userData => userData)
      .catch(() => console.log('Not signed in'));
  }

  return (
    <>
        {SignOutAll()}
    </>
  );
}

export default SignOut;